import {useInsertionEffect, useState} from 'react';

export function usePrevious<T>(currentValue: T, equals: (a: T, b: T) => boolean = (a, b) => a === b): T | null {
    const [swap] = useState(() => ({
        willBePrevious: currentValue,
        previous: null as T | null,
    }));

    let patch = swap;
    if (!equals(currentValue, swap.willBePrevious)) {
        patch = {
            willBePrevious: currentValue,
            previous: swap.willBePrevious,
        };
    }

    useInsertionEffect(() => {
        if (swap !== patch) {
            swap.previous = patch.previous;
            swap.willBePrevious = patch.willBePrevious;
        }
    });

    return patch.previous;
}
